import { useSearchParams } from 'react-router';
import { Paper, Stack, Typography } from '@mui/material';

import { CreateGiftButton } from '../components/CreateGiftButton';
import { GiftScheduleCalendar } from '../components/GiftScheduleCalendar';
import { ImportGiftsButton } from '../components/ImportGiftsButton';

export const GiftSchedulerPage = () => {
    const [params] = useSearchParams();

    const isDebug = params.has('debug');

    return (
        <Stack spacing={2}>
            <Paper
                variant="outlined"
                sx={{
                    p: 1.5,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 1,
                    borderRadius: 2,
                }}
            >
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    Scheduled gifts
                </Typography>
                <Stack direction="row" spacing={1}>
                    {isDebug && <CreateGiftButton />}
                    <ImportGiftsButton />
                </Stack>
            </Paper>

            <Paper
                variant="outlined"
                sx={{ p: { xs: 1.5, sm: 2 }, borderRadius: 2 }}
            >
                <GiftScheduleCalendar />
            </Paper>
        </Stack>
    );
};
